// Reusable class combinations
export const baseClasses = {
  // Card styling
  card: "bg-[color:var(--surface-container)] rounded-xl shadow-md",
  cardBordered:
    "bg-[color:var(--surface-container)] rounded-xl border border-[color:var(--outline-variant)]",

  // Input base styling
  input:
    "border border-[color:var(--outline)] rounded-lg bg-[color:var(--surface-container)] text-[color:var(--on-surface)] placeholder-[color:var(--on-surface-variant)] hover:border-[color:var(--outline)] focus:outline-none focus:ring-1 focus:ring-[color:var(--primary)] focus:border-[color:var(--primary)]",

  // Button base styling
  button:
    "font-medium rounded-lg transition-colors focus:outline-none focus:ring-1 focus:ring-[color:var(--primary)]",

  // Table styling
  tableRow:
    "border-b border-[color:var(--outline-variant)] hover:bg-[color:var(--surface-container-high)] transition-colors",
  tableCell: "px-6 py-4",

  // Tab styling
  tab: "py-4 border-b font-medium text-sm transition-colors",
  tabActive:
    "border-[color:var(--role-action)] text-[color:var(--role-action)]",
  tabInactive:
    "border-transparent text-[color:var(--on-surface-variant)] hover:text-[color:var(--on-surface)]",

  // Section styling
  section: "bg-[color:var(--surface-container)] rounded-xl shadow-md p-6",
  sectionHeader:
    "px-6 py-4 border-b border-[color:var(--outline-variant)] flex items-center justify-between",

  // Modal styling
  modalOverlay:
    "fixed inset-0 bg-[color:var(--scrim)] flex items-center justify-center z-overlay",
  modalContent:
    "bg-[color:var(--surface-container-high)] rounded-xl max-w-lg w-full shadow-xl",

  // Spinner styling
  spinner:
    "w-8 h-8 border-2 border-[color:var(--primary)] border-t-transparent rounded-full animate-spin",
} as const;

// Helper function to combine classes
export const cx = (...classes: (string | undefined | null | false)[]) => {
  return classes.filter(Boolean).join(" ");
};
